var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mt-3",attrs:{"id":"table_5"}},[_vm._v(" Gevraagde en gerealiseerde laadpunten per stelsel ")]),_c('TableManager',{ref:"TableManager",staticClass:"RVBChargingpointCount",attrs:{"loading":_vm.loading,"source-records":_vm.records,"category":"rvb-customer-reporting","uuid":"67d40fce-cd01-435b-ad2c-6574e1bc4c8c"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }